<template>
  <CreationRead v-if="Town" :town="Town" :key="townKey" />
</template>

<script>
import CreationRead from "@/components/plugins/CreationRead.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreationTownView",
  components: { CreationRead },
  created() {
    // nouvelle méthode du store : on cherche l'entité par la ville (town)
    const townParam = this.$route.params.town;
    if (townParam) {
      this.$store.dispatch("GetTownByTown", townParam);
    }
  },

  data() {
    return {
      form: {
        content: "",
        article: "",
      },
      formVisible: false,
      showError: false,
      townKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      Token: "StateToken",
      User: "StateUser",
      Town: "StateTown",
    }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  watch: {
    Town: {
      handler(newVal, oldVal) {
        // Vérifie si Town a effectivement changé
        if (newVal && newVal !== oldVal) {
          this.townKey += 1; // Change la clé pour forcer le re-rendu de CreationRead
        }
      },
      deep: true, // Assure que les changements profonds sont détectés
    },
  },
  methods: {
    // on ajoute la nouvelle méthode du store ici
    ...mapActions(["GetTowns", "GetTown", "GetTownByTown"]),
  },
};
</script>
